// color-exempt-file — retokenisation Phase 6 ui-themes : dark:bg-[#030712] preserve le rendu dark historique (voir memoire ui-themes)
import React from "react";
import {
  Mail,
  Phone,
  MessageSquare,
  Clock,
  Shield,
  HelpCircle,
} from "lucide-react";
import { useTranslation } from "react-i18next";
import { ProductHeader } from "@core/components/layout/products/ProductHeader";
import { ProductSidebar } from "@core/components/layout/products/ProductSidebar";
import { SEOHead } from "../components/SEOHead";
import { brandForProductType } from "@core/lib/brand-config";

export const SupportPage: React.FC = () => {
  const { t } = useTranslation(["polls", "common"]);
  const brand = brandForProductType("date");
  return (
    <div className="flex flex-col min-h-screen-safe bg-background dark:bg-[#030712] text-foreground">
      <SEOHead
        title={t("polls:support_seo_title")}
        description={t("polls:support_seo_description")}
      />
      <ProductHeader productType="date" showAuth={true} />
      <div className="flex flex-1">
        <ProductSidebar productType="date" />
        <div className="flex-1">
          <div className="max-w-4xl mx-auto px-6 py-16">
            {/* Header */}
            <div className="text-center mb-16">
              <div className="w-16 h-16 rounded-2xl bg-primary/20 flex items-center justify-center mx-auto mb-6 border border-border">
                <HelpCircle className="w-8 h-8 text-primary" />
              </div>
              <h1 className="text-4xl md:text-5xl font-bold mb-4">
                {t("polls:support_title")}
              </h1>
              <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
                {t("polls:support_subtitle")}
              </p>
            </div>

            {/* Contact Info */}
            <div className="bg-card backdrop-blur-sm border border-border rounded-2xl p-8 mb-12">
              <h2 className="text-2xl font-bold mb-6 flex items-center gap-3">
                <MessageSquare className="w-6 h-6 text-primary" />
                {t("polls:support_contact_us")}
              </h2>

              <div className="grid md:grid-cols-2 gap-8">
                {/* Email */}
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-xl bg-primary/20 flex items-center justify-center flex-shrink-0">
                    <Mail className="w-6 h-6 text-primary" />
                  </div>
                  <div>
                    <h3 className="font-semibold mb-2">
                      {t("polls:support_email_label")}
                    </h3>
                    <p className="text-muted-foreground mb-1">
                      {brand.supportEmail}
                    </p>
                    <p className="text-sm text-muted-foreground">
                      {/* Réponse sous 24h ouvrées */}
                    </p>
                  </div>
                </div>

                {/* Support prioritaire */}
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-xl bg-warning/20 flex items-center justify-center flex-shrink-0">
                    <Shield className="w-6 h-6 text-warning" />
                  </div>
                  <div>
                    <h3 className="font-semibold mb-2">
                      {t("polls:support_priority_title")}
                    </h3>
                    <p className="text-muted-foreground text-sm">
                      {t("polls:support_priority_description")}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* FAQ Preview */}
            <div className="bg-card backdrop-blur-sm border border-border rounded-2xl p-8">
              <h2 className="text-2xl font-bold mb-6">
                {t("polls:support_faq_title")}
              </h2>

              <div className="space-y-4">
                <div className="p-4 rounded-lg bg-muted/30 border border-border/50">
                  <h3 className="font-semibold mb-2">
                    {t("polls:support_faq_q1")}
                  </h3>
                  <p className="text-muted-foreground text-sm">
                    {t("polls:support_faq_a1")}
                  </p>
                </div>

                <div className="p-4 rounded-lg bg-muted/30 border border-border/50">
                  <h3 className="font-semibold mb-2">
                    {t("polls:support_faq_q2")}
                  </h3>
                  <p className="text-muted-foreground text-sm">
                    {t("polls:support_faq_a2")}
                  </p>
                </div>

                <div className="p-4 rounded-lg bg-muted/30 border border-border/50">
                  <h3 className="font-semibold mb-2">
                    {t("polls:support_faq_q3")}
                  </h3>
                  <p className="text-muted-foreground text-sm">
                    {t("polls:support_faq_a3")}
                  </p>
                </div>
              </div>

              <div className="mt-6 text-center">
                <p className="text-muted-foreground">
                  {t("polls:support_other_help")}
                  <a
                    href={`mailto:${brand.supportEmail}`}
                    className="text-primary hover:text-primary/80 ml-1"
                  >
                    {t("polls:support_contact_directly")}
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
